import React, { useEffect } from 'react';
import {
  Navigate,
  Route,
  Routes,
  unstable_HistoryRouter as HistoryRouter,
  useLocation,
} from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { alertActions } from '../_actions';
import { history } from '../_helpers/history';
import { PrivateRoute } from '../_components';
import { LoginPage } from '../LoginPage';
import '../_assets/main.scss';
import { Vacancies } from '../Vacancies';
import Profile from '../Profile';
import { Applicants } from '../Applicants';
import ScrollToTop from '../_components/ScrollToTop';
import { Companies } from '../Companies';
import { DetailVacancy } from '../DetailVacancy';
import { DetailApplicant } from '../DetailApplicant';
import { CompaniesDetail } from '../CompaniesDetail';

function AppRoutes() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(alertActions.clear());
  }, [dispatch, location.pathname, location.search]);

  return (
    <ScrollToTop>
      <Routes>
        <Route
          path="/applicants"
          element={
            <PrivateRoute>
              <Applicants />
            </PrivateRoute>
          }
        />
        <Route
          path="/vacancies"
          element={
            <PrivateRoute>
              <Vacancies />
            </PrivateRoute>
          }
        />
        <Route
          path="/companies"
          element={
            <PrivateRoute>
              <Companies />
            </PrivateRoute>
          }
        />
        <Route
          path="/companies/:id"
          element={
            <PrivateRoute>
              <CompaniesDetail />
            </PrivateRoute>
          }
        />
        <Route
          path="/profile/*"
          element={
            <PrivateRoute>
              <Profile />
            </PrivateRoute>
          }
        />
        <Route
          path="/vacancies-detail/:key"
          element={
            <PrivateRoute>
              <DetailVacancy />
            </PrivateRoute>
          }
        />
        <Route
          path="/applicants/:key"
          element={
            <PrivateRoute>
              <DetailApplicant />
            </PrivateRoute>
          }
        />
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </ScrollToTop>
  );
}

function App() {
  return (
    <HistoryRouter
      history={history}
      future={{ v7_relativeSplatPath: true, v7_startTransition: true }}
    >
      <AppRoutes />
    </HistoryRouter>
  );
}

export { App };
